import { AxiosInstance, AxiosResponse } from 'axios';
import { Model3dCreateDto } from './inputs/model3d-create.input';
import { Model3dUpdateDto } from './inputs/model3d-update.input';
import { Model3dCreateResponse } from './responses/model3d-create.response';
import { Model3dDeleteResponse } from './responses/model3d-delete.response';
import { Model3dEntryResponse } from './responses/model3d-entry.response';

export class Models3dModuleClient {
  constructor(private readonly client: AxiosInstance) {}

  async createOne(dto: Model3dCreateDto): Promise<AxiosResponse<Model3dCreateResponse>> {
    return await this.client.post('/models3d', dto);
  }

  async getOne(id: string): Promise<AxiosResponse<Model3dEntryResponse>> {
    return await this.client.get(`/models3d/${id}`);
  }

  async getMany(): Promise<AxiosResponse<Model3dEntryResponse[]>> {
    return await this.client.get(`/models3d`);
  }

  async updateOne(id: string, dto: Model3dUpdateDto): Promise<AxiosResponse<Model3dEntryResponse>> {
    return await this.client.put(`/models3d/${id}`, dto);
  }

  async deleteOne(id: string): Promise<AxiosResponse<Model3dDeleteResponse>> {
    return await this.client.delete(`/models3d/${id}`);
  }

  async reportUpload(id: string): Promise<AxiosResponse<void>> {
    return await this.client.patch(`/models3d/${id}/report-upload`);
  }
}
